import { useEffect, useState } from "react";
import moment from "moment";
import { authToken, PAGE } from "@/Api";
import { useNavigate } from "react-router-dom";
import { Header } from "react-frontier";
import { useUser } from "@/hooks/useUser";

var AuthResponse=()=>{
   var {logout, setUser}=useUser();
   var navigate=useNavigate();
   var [loginError,setLoginError]=useState<string>(null);
   
   useEffect(()=>{
      var url=new URLSearchParams(window.location.search);
		var token=url.get('at');
		var redirect=url.get('r');
      var expiration=parseInt(url.get('e'));
      var now=moment().unix();

      if(!expiration || Number.isNaN(expiration) || expiration<(now+30)) return setLoginError('La autenticación de usuario ha expirado');
      if(!redirect||redirect.length<9)redirect=PAGE;
		
      var isLocalRoute=false;
		
      if(redirect.startsWith(window.location.origin)){
			isLocalRoute=true;
			redirect=redirect.substring(window.location.origin.length);
		}
      
      authToken(token).then(res=>{
         if(res.error)return setLoginError(res.message);
         setUser(res.data);
         if(redirect){
            if(isLocalRoute && navigate)return navigate(redirect);
            return window.location.href = redirect;
         }
         if(navigate)return navigate('/');
         return window.location.href=PAGE
      }).catch(()=>{
         return setLoginError('Hubo un error inesperado haciendo login. (LCL-AUTHRP-1)')
      })
   },[navigate, setUser]);
   
	if(loginError){
		return <div style={{ marginTop: 20 }}>
			<Header text='Error' size='big' centered subtext={`Hubo un error inesperado haciendo login: ${loginError}`} style={{ maxWidth: 500, margin: 'auto' }} />
			<div className="fr black basic button" style={{ margin: 'auto', display: 'block', width: 150, marginTop: 20 }} onClick={logout}>
				Cerrar sesión
			</div>
		</div>
	}
	
	return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<div>
         <img src="https://cdn.arema.dev/assets/logo/Logo_Small.webp" alt="" />
      </div>
	</div>
}

export default AuthResponse;